import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useState } from "react";

interface SectionCardProps {
  icon: React.ReactNode;
  title: string;
  children: React.ReactNode;
  expanded: boolean;
  onExpandChange: (v: boolean) => void;
  highlighted?: boolean;
}

export default function SectionCard({
  icon,
  title,
  children,
  expanded,
  onExpandChange,
  highlighted = false,
}: SectionCardProps) {
  return (
    <Accordion
      expanded={expanded}
      onChange={(_, v) => onExpandChange(v)}
      disableGutters
      elevation={0}
      sx={{
        border: "0.5px solid",
        borderColor: highlighted ? "primary.300" : "grey.200",
        borderRadius: "12px !important",
        overflow: "hidden",
        "&:before": { display: "none" },
        transition: "border-color 0.3s",
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon sx={{ fontSize: 16, color: "text.secondary" }} />}
        sx={{
          minHeight: 44,
          px: 2,
          bgcolor: highlighted ? "primary.50" : "grey.50",
          transition: "background-color 0.3s",
          "& .MuiAccordionSummary-content": { my: 0, display: "flex", alignItems: "center", gap: 1 },
          "&:hover": { bgcolor: highlighted ? "primary.100" : "grey.100" },
        }}
      >
        <Box sx={{ color: "text.secondary", display: "flex", fontSize: 16 }}>{icon}</Box>
        <Typography fontSize={13} fontWeight={500} color="text.primary">
          {title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ p: 0, borderTop: "0.5px solid", borderColor: "grey.200" }}>{children}</AccordionDetails>
    </Accordion>
  );
}
